// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '바이넥스',
  targetSheetName: '26Y_수수료율표(26.6)',
  headerRowIndex: 5,
  headerRowCount: 1,
  dataStartRowIndex: 6,
  // 66·125행 중복 헤더 이후 블록 계속 읽기
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드 (점검코드)',
    drugName: '제품명',
    price: '보험약가(원)',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '등급',
    '제품명',
    '성분명',
    '보험약가(원)',
    '보험코드 (점검코드)',
    '수수료율',
    '매출구간별 추가수수료',
    '비고',
  ],
  // 헤더 D열=제품명이지만 병합(D~F)으로 데이터는 E열(index 4)
  columnIndexOverrides: {
    drugName: 4,
  },
});
